import { INVALIDATE_VENTES } from 'actions/invalidationTags';
import { ApiMananger } from "actions/rtkquery";
import { GET_VENTE_API_ROUTE } from "routes/api/endpoints";

const venteApi = ApiMananger.injectEndpoints({
    endpoints: (build) => ({
      
    getVente: build.query({
        query: ({ dossier_id }) => `${GET_VENTE_API_ROUTE}?dossier_id=${dossier_id}&page=1&page_size=100`,
        providesTags: [INVALIDATE_VENTES],
    }),
    getVenteId: build.query({
        query: ({ dossier_id, id }) => `${GET_VENTE_API_ROUTE}?dossier_id=${dossier_id}&id=${id}&page=1&page_size=100`,
        providesTags: [INVALIDATE_VENTES],
    }),
}),
});

export const {
useGetVenteQuery,
useGetVenteIdQuery,
} = venteApi;
